import Vue from 'vue';
import Toast, { POSITION, TYPE } from 'vue-toastification';
import { PluginOptions } from 'vue-toastification/dist/types/src/types';
import 'vue-toastification/dist/index.css';
import '@/assets/css/toast.scss';
import { showToast } from '@/utils/toast';

export const toastPluginOptions: PluginOptions = {
  position: POSITION.TOP_CENTER,
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  icon: true,
  rtl: false,
  maxToasts: 3,
  newestOnTop: true,
  toastClassName: 'game-toast',
  bodyClassName: 'game-toast__body',
  containerClassName: 'game-toast-container',
  toastDefaults: {
    [TYPE.ERROR]: {
      timeout: 5000,
    },
    [TYPE.SUCCESS]: {
      timeout: 3000,
      hideProgressBar: true,
    },
  },
};

export function installToastPlugin(): void {
  Vue.use(Toast, toastPluginOptions);
  Vue.prototype.$showToast = showToast;
}

export { POSITION, TYPE };
